<template>
  <v-card
      v-if="!isEmpty(applicationType)"
      flat column>
    <v-subheader>
      Pedido
    </v-subheader>
    <v-card
        flat
        class="ml-3 px-4 py-2"
        color="grey lighten-5">
      <v-layout column>
        <span>
        <strong>Tipo de Requerimento</strong>
        </span>
        <span>
          {{ applicationType.applicationTypeSelected.acronym }} - {{ applicationType.applicationTypeSelected.name }}
        </span>
        <span>
          <strong>Pedido </strong>
        </span>
        <span>
          {{ applicationType.subject }}
        </span>
      </v-layout>
    </v-card>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'ResumeApplicationType',
  data() {
    return {
      isEmpty
    }
  },
  computed: {
    ...mapGetters('newApplication', ['newApplication']),
    applicationType() {
      return this.newApplication.applicationType;
    },
  },
};
</script>
